import React from 'react';
import { Container } from 'react-bootstrap';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { BoxArrowInUpRight } from 'react-bootstrap-icons';
import './PlanEstrategicoView.css';

const PlanEstrategicoView = () => {
  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Plan Estratégico"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <div>
          <a
            href="https://lookerstudio.google.com/embed/u/0/reporting/cb3db56e-f5a6-4f91-bea1-d5bc308b0c6d/page/p_r7uqn4hi5c"
            target="_blank"
            rel="noreferrer"
            className="plan-link"
          >
            Guía de Inversiones <BoxArrowInUpRight />
          </a>
        </div>
        <div>
          {' '}
          <a
            href="https://www.villalaangosturaturismo.gob.ar/estadisticas/"
            target="_blank"
            rel="noreferrer"
            className="plan-link"
          >
            Estadísticas <BoxArrowInUpRight />
          </a>
        </div>
        <div>
          {' '}
          <a
            href="https://sistemasmvla.com.ar/Economia-Circular-Ago2024.pdf"
            target="_blank"
            rel="noreferrer"
            className="plan-link"
          >
            Economia Circular VLA - Analisis de Situación y Recomendaciones <BoxArrowInUpRight />
          </a>
        </div>
        <div>
          {' '}
          <a
            href="https://sistemasmvla.com.ar/PPT-Economia-Circular-Agosto-2024.pdf"
            target="_blank"
            rel="noreferrer"
            className="plan-link"
          >
            PPT - Economia Circular VLA - Analisis de Situación y Recomendaciones{' '}
            <BoxArrowInUpRight />
          </a>
        </div>
      </Container>
    </>
  );
};

export default React.memo(PlanEstrategicoView);
